import React from 'react';
import { Modal } from 'antd';

import { OverlayLoader } from 'components';
import BaseModalTitle from './components/BaseModalTitle';

import { IBaseModalProps } from './BaseModal.types';

import './BaseModal.styles.scss';

const BaseModal = ({
  children,
  maxWidth,
  icon,
  title,
  loading,
  fullScreen,
  footer = [],
  style = {},
  className = '',
  onClose,
  ...props
}: IBaseModalProps) => {
  const fullScreenClass = fullScreen ? 'np-base-modal--full-screen' : '';

  return (
    <Modal
      centered
      destroyOnHidden
      footer={footer}
      title={<BaseModalTitle title={title} icon={icon} />}
      className={`np-base-modal ${fullScreenClass} ${className}`}
      style={{ maxWidth, ...style }}
      onCancel={onClose}
      {...props}
    >
      {loading && <OverlayLoader borderRadius={16} size="large" />}

      {children}
    </Modal>
  );
};

export default BaseModal;
